import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

interface CargoDistributionAreaListPayload {
    cargoId: number;
    cityId: number;
    countyId: number;
    distributionTypeId: number;
    page: number;
    pageSize: number;
}

const CargoDistributionAreaList = (params: CargoDistributionAreaListPayload): Promise<any> =>
    request({
        url: ApiURL.Command.CargoDistributionAreaList,
        method: RequestType.POST,
        data: params,
    });

const CargoCompanyDistributionAreasCommand = {
    CargoDistributionAreaList,
};

export default CargoCompanyDistributionAreasCommand;

